import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AddBatchDTO, AddSupplierBatchDTO, BatchPaginationDTO, HideBatchDTO, RestockBatchDTO, ValidateBatchDTO } from "../../dtos/batch";
import BatchService from "./batchService";

// Define initial state
const initialState = {
    batchDetails: [],
    supplierBatchDetails: [],

  batchId: "",
  isLoading: false,
  isSuccess: false,
  isError: false,
  message: <any>"",
  supplierBatchmessage: <any>"",

  isBatchLoading: false,

  issupBatchLoading: false,
  issupBatchSuccess: false,

  isBatchLoadingError: false,
  isSupplierBatchError: false,
};

export const AddBatch = createAsyncThunk(
  "api/pharmacy/batch/add",
  async (batch: AddBatchDTO, thunkAPI) => {
    try {
      return await BatchService.AddBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const AddSupplierBatch = createAsyncThunk(
  "api/pharmacy/supplier_batch/add",
  async (supplierbatch: AddSupplierBatchDTO, thunkAPI) => {
    try {
      return await BatchService.AddSupplierBatch(supplierbatch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const editBatch = createAsyncThunk(
  "batch/edit",
  async (batch: AddBatchDTO, thunkAPI) => {
    try {
      return await BatchService.editBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const restockBatch = createAsyncThunk(
  "batch/restock",
  async (batch: RestockBatchDTO, thunkAPI) => {
    try {
      return await BatchService.restockBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const hideBatch = createAsyncThunk(
  "batch/hide",
  async (batch: HideBatchDTO, thunkAPI) => {
    try {
      return await BatchService.HideBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const getBatchData = createAsyncThunk(
  "batch/getBatchData", 
  async ({ pharmacy_id, dto }: { pharmacy_id: any; dto?: BatchPaginationDTO }, thunkAPI) => {
    try {
      const response = await BatchService.getBatch(pharmacy_id, dto); 
      return response.data; 
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const validateBatch = createAsyncThunk(
  "batch/validate_batch",
  async (batch: ValidateBatchDTO, thunkAPI) => {
    try {
      return await BatchService.validateBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);
export const getAllMedBatch = createAsyncThunk(
  "batch/getAllMedBatch",
  async (batch: ValidateBatchDTO, thunkAPI) => {
    try {
      return await BatchService.getAllMedBatch(batch);
    } catch (error: any) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const batchSlice = createSlice({
  name: "batchSlice",
  initialState,
  reducers: {
    reset: () => initialState,
    changeBatchId: (state, action) => {
      state.batchId = action.payload.batch_list;
    },
    
  },

  extraReducers: (builder) => {
    builder
      .addCase(getBatchData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getBatchData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.batchDetails = action.payload.batch_list;
        state.message = "";
      })
      .addCase(getBatchData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.message = action.payload;
      })
      .addCase(AddSupplierBatch.pending, (state) => {
        state.issupBatchLoading = true;
      })
      .addCase(AddSupplierBatch.fulfilled, (state, action) => {
        state.issupBatchLoading = false;
        state.issupBatchSuccess = true;
        state.supplierBatchDetails = action.payload.batch_list;
        state.supplierBatchmessage = "";
      })
      .addCase(AddSupplierBatch.rejected, (state, action) => {
        state.issupBatchLoading = false;
        state.isSupplierBatchError = true;
        state.supplierBatchmessage = action.payload;
      });
  },
});

// Export actions and reducer
export const { reset, changeBatchId } = batchSlice.actions;
export default batchSlice.reducer;